import React, { useEffect } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import { getUserIdFromQueryParams } from '../../utils/url-params';
import { resetChoosedTemplate } from '../../actions/template';
import { getUser, getUsers, getMatchedUsers } from '../../actions/users';
import debounce from '../../utils/debounce';

const UserNavigationSrceen = ({
  users,
  user,
  getUsers,
  resetChoosedTemplate,
  getUser,
  getMatchedUsers,
  isUsersDataLoading,
  loader,
  isGetComplex,
  title,
}) => {
  useEffect(() => {
    const getComplex = isGetComplex || true;
    !users.length && getUsers(false, getComplex);
  }, []);
  const usersDataForSelect = users.map((user) => ({
    name: `${user.name} (${user.id})`,
    id: user.id,
  }));
  getUserIdFromQueryParams() && usersDataForSelect.push({ name: user.name, id: user.id });

  const handleUpdateUserValue = (value) => {
    resetChoosedTemplate();
    const getComplex = isGetComplex || true;
    getUser(value, getComplex);
  };

  const handleUpdateText = (value) => {
    value.length > 1 && getMatchedUsers(value);
  };

  return (
    <React.Fragment>
      <TabBlock>
        <StyledLink to="/controlUsers">Управление пользователем</StyledLink>
        <StyledLink exact to="/">
          Назначение курса
        </StyledLink>
        {/* <Button to="/motivationVideos">Мотивация</Button> */}
      </TabBlock>
      <MainTitle>{title}</MainTitle>
      <H1>Выберите пользователя</H1>
      <UserBlock>
        <Select
          options={usersDataForSelect}
          simpleValue
          clearable
          name="select-user"
          value={user.id}
          onChange={handleUpdateUserValue}
          onInputChange={debounce(handleUpdateText, 1000)}
          searchable
          labelKey="name"
          valueKey="id"
          placeholder="Выберите пользователя..."
          isLoading={isUsersDataLoading}
          disabled={loader}
        />
      </UserBlock>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const { users, user, isUsersDataLoading } = state.reducers;
  const { isShowRecommendedTemplate } = state.folders;
  const { selectedComplex } = state.complex;
  const { loader } = state.loader;
  return {
    users,
    user,
    isUsersDataLoading,
    isShowRecommendedTemplate,
    selectedComplex,
    loader,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetChoosedTemplate: () => {
      dispatch(resetChoosedTemplate());
    },
    getUser: (userId, getComplex) => {
      dispatch(getUser(userId, getComplex));
    },
    getMatchedUsers: (usernameValue) => {
      dispatch(getMatchedUsers(usernameValue));
    },
    getUsers: (userActionResult, inMenuList) => {
      dispatch(getUsers(userActionResult, inMenuList));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserNavigationSrceen);

const UserBlock = styled.div`
  margin: 0 auto;
  width: 100%;
`;
const TabBlock = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
`;

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  padding: 0px 5px;
  margin-left: 5px;
  height: 50px;
  width: 20%;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background: #17ade3;
  color: #fff;
  border-radius: 5px;
  border: 1px solid #000542;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/UsersSubnavigation/UserNavigationScreen.jsx